import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import {AuthNewService} from '../../service/auth-new.service';
import {User} from '../../model/types';
import { URLUtil } from '../../../utils';
import {DialogComponent} from '../dashboard/dialog/dialog.component';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { DownLoadService } from '../../service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  signedInUser: User;
  baseUrl: string;
  data: any;

  @ViewChild('player', {static: false}) player: any;
  videoId: string;

  @Input()
  set id(id: string) {
    this.videoId = id;
  }

  constructor(private authService: AuthNewService, private router: Router, public dialog: MatDialog,
    private downloadService: DownLoadService,
  ) { }

  ngOnInit() {
    this.baseUrl = URLUtil.getBaseUrl();

    if (window.location.href.indexOf('code') !== -1) {
      // Setup local tokens/data if coming from OpenID redirect
      const code = URLUtil.getAuthCode();
      this.authService.getTokensWithCode(code).then(tokens => {
//         console.log(tokens);
        this.authService.setAmplifySession(tokens);
        this.authService.setUserData();
//         console.log(this.authService.getAuthenticatedUser());
        const url = new URL(window.location.href);
        let urlString = url.toString();
        urlString = urlString.replace(/\?code\=.+/g, '#/default-layout/new-analysis');
        window.location.href = urlString;
//         this.router.navigate(['default-layout/new-analysis'])
      }).catch(error => {
        const url = new URL(window.location.href);
        let urlString = url.toString();
        urlString = urlString.replace(/\?code\=.+/g, '#/default-layout/new-analysis');
        window.location.href = urlString;
//         this.router.navigate(['default-layout/new-analysis'])
      })
    }
  }

  public downloadFile(key: string) {
    // console.log('Key for download ', key)
    this.downloadService.getS3Obj(key).then(data => {
      console.log('imageData-->', data)
      // this.data = JSON.parse(data);
      // console.log('Formatted Object ', this.data);
      // const result = new TextDecoder('utf-8').decode(data.Body);
      // console.log('Chromatogram file', result)
    });
    // const s3_path = this.downloadService.getUrl(key);
    // console.log("s3",s3_path)

  }


  openDialog(data) {
    this.dialog.open(DialogComponent, {data: {name: data}, disableClose: false});
   }

}
